module.exports = __webpack_public_path__ + "img/spiral-details18.99869c2a.png";